module.exports = __webpack_public_path__ + "img/icon_submenu19.6f4513a5.svg";